import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEsp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_9162_14682",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 17,
		height: 17,
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_9162_14682)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 2L8.5 -2L17 2V5.46667H0V2ZM0 11.5333H17V15L8.5 19L0 15V11.5333Z",
				fill: "#D03433"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 5.45906H17V11.5409H0V5.45906Z",
				fill: "#FBCA46"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.89308 8.06667H6.64864V8.5H5.89308V8.06667Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.43949 9.36667C5.43949 9.62667 5.66616 9.8 5.89283 9.8C6.11949 9.8 6.34616 9.62667 6.34616 9.36667L6.42172 8.06667H5.36394L5.43949 9.36667ZM4.98616 8.06667C4.98616 7.80667 5.13727 7.63333 5.28838 7.63333H6.42172C6.64838 7.63333 6.79949 7.80667 6.79949 7.98V8.06667L6.72394 9.36667C6.64838 9.88667 6.34616 10.2333 5.89283 10.2333C5.43949 10.2333 5.13727 9.88667 5.06172 9.36667L4.98616 8.06667Z",
				fill: "#A41517"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.13668 8.5H6.64864L6.64779 8.93333H6.27002L5.89283 9.8L5.51446 8.93333H5.13668V8.5ZM4.00335 7.2H4.7589V10.2333H4.00335V7.2ZM7.02557 7.2H7.78113V10.2333H7.02557V7.2ZM5.13668 6.76667C5.13668 6.50667 5.28779 6.33333 5.51446 6.33333H6.27002C6.49668 6.33333 6.64779 6.50667 6.64779 6.76667V6.94C6.64779 7.11333 6.57224 7.2 6.42113 7.2H5.28779C5.21224 7.2 5.13668 7.11333 5.13668 7.02667V6.76667Z",
				fill: "#A41517"
			})
		]
	})]
});
export default SvgEsp;
